module.exports = __webpack_public_path__ + "static/img/draug.ae22b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/draug.png
// module id = 0xx3
// module chunks = 0